import { render, staticRenderFns } from "./HisData.vue?vue&type=template&id=1a6091fd&scoped=true&"
import script from "./HisData.vue?vue&type=script&lang=js&"
export * from "./HisData.vue?vue&type=script&lang=js&"
import style0 from "./HisData.vue?vue&type=style&index=0&id=1a6091fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6091fd",
  null
  
)

export default component.exports